import { useState } from 'react'
import { graphql } from 'app/generated/gql'
import { opsClient } from 'app/lib/opsUrqlClient'

// cacheFlush lives in the ops schema. The resolver refuses an empty prefix so a
// typo cannot evict the whole cache.
const CACHE_FLUSH_MUTATION = graphql(`
  mutation CacheFlush($pattern: String!) {
    cacheFlush(pattern: $pattern) {
      success
      error
    }
  }
`)

export type UseFlushReturn = {
  pattern: string
  setPattern: (pattern: string) => void
  flushing: boolean
  message: string
  flush: () => Promise<void>
}

export function useFlush(): UseFlushReturn {
  const [pattern, setPattern] = useState(``)
  const [flushing, setFlushing] = useState(false)
  const [message, setMessage] = useState(``)

  const flush = async () => {
    setFlushing(true)
    setMessage(``)
    const result = await opsClient.mutation(CACHE_FLUSH_MUTATION, { pattern }).toPromise()
    setFlushing(false)
    const failure = result.error?.message ?? result.data?.cacheFlush.error
    if (failure || !result.data?.cacheFlush.success) {
      setMessage(`Flush failed: ${failure ?? `unknown error`}`)
      return
    }
    setMessage(`Cache flushed for prefix "${pattern}"`)
  }

  return { pattern, setPattern, flushing, message, flush }
}
